var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.useFallback)?[(_vm.matches)?_vm._t("default"):_vm._t("fallback")]:_vm._t("default",null,{"matches":_vm.matches})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }